import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

export function extract(key: string, defaultValue?: string): string {
  return defaultValue || key;
}

i18n
  .use(detector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    lng: localStorage.i18nextLng || "hu",
    load: "languageOnly",
    fallbackLng: "hu",
    interpolation: {
      escapeValue: false,
    },
    react: {
      wait: true,
    },
  });

export default i18n;
